import React from 'react';
import PropTypes from 'prop-types';
import BirthdayInput from './birthday-input';
import './index.css';

const BirthdayPicker = (props) => {
  return (
    <div className="birthday-input">
      <BirthdayInput
        handleUpdate={ props.handleUpdate }
        birthday={ props.birthday }
      />
    </div>
  );
};

BirthdayPicker.propTypes = {
  /** The date on which the picker will start */
  birthday: PropTypes.string,
  /** Function required for BirthdayInput component */
  handleUpdate: PropTypes.func.isRequired
};

export default BirthdayPicker;
